var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"w-support-email-address",attrs:{"href":'mailto:' + _vm.$metadatas.supportEmailAddress}},[_c('span',{domProps:{"textContent":_vm._s(_vm.$metadatas.supportEmailAddress)}}),_vm._v(" "),(_vm.noIcon === false)?_c('v-icon',{attrs:{"size":"medium"}},[_vm._v("mdi-at")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }